import { render, staticRenderFns } from "./GymPassDetail.vue?vue&type=template&id=349d9132"
import script from "./GymPassDetail.vue?vue&type=script&lang=js"
export * from "./GymPassDetail.vue?vue&type=script&lang=js"
import style0 from "./GymPassDetail.vue?vue&type=style&index=0&id=349d9132&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports